import { get, upload, put } from '@api/request';

export async function fetchValuationImports(
  { importService },
  authenticationToken,
) {
  const url = `${importService}/import/valuations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchValuationImport(
  { importService },
  authenticationToken,
  { importID },
) {
  const url = `${importService}/import/valuation/${importID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createValuationImport(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/valuations`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function updateValuationImport(
  { importService },
  authenticationToken,
  { importID, payload },
) {
  const url = `${importService}/import/valuation/${importID}/createvaluations`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchValuationImportErrors(
  { importService },
  authenticationToken,
  { importID },
) {
  const url = `${importService}/import/valuation/${importID}/propertyerrors`;
  const { body } = await get(authenticationToken, url);
  return body;
}
